import {
	CreateBusinessProcessPayload,
	GetBusinessProcessListPayload,
	UpdateBusinessProcessPayload,
} from '@/api/businessProcesses/request';
import {
    GetBusinessProcessActionsResponse,
    GetBusinessProcessListResponse,
    GetBusinessProcessResponse,
} from '@/api/businessProcesses/response';
import { ClientService } from '@/types/api';
import { BusinessProcessDictionaryDto } from '@/api/generated/models/businessProcessDictionaryDto';

export class BusinessProcessesAPI {
	private prefix = 'v2/business-processes';

	constructor(private readonly clientService: ClientService) {
		this.clientService = clientService;
	}

	/**
	 *
	 * @param projectId
	 */
	public async getBusinessProcessesByProjectId(projectId: number): Promise<GetBusinessProcessResponse> {
		const { data } = await this.clientService.get<GetBusinessProcessResponse>(
			`${this.prefix}/project/${projectId}`
		);

		return data;
	}

	public async createBusinessProcess(payload: CreateBusinessProcessPayload) {
		return this.clientService.post<number>(`${this.prefix}`, payload);
	}

	public async updateBusinessProcess({ businessProcessId, ...body }: UpdateBusinessProcessPayload) {
		return this.clientService.put<number>(`${this.prefix}/${businessProcessId}`, body);
	}

	public async deleteBusinessProcess(id: number) {
		await this.clientService.delete(`${this.prefix}/${id}`);
	}

	public async getBusinessProcess(businessProcessId: number) {
		return this.clientService.get<GetBusinessProcessResponse>(`${this.prefix}/${businessProcessId}`);
	}

	public async getBusinessProcessList({ filters, ...params }: GetBusinessProcessListPayload) {
		return this.clientService.post<GetBusinessProcessListResponse>(`${this.prefix}/list`, filters, {
			params,
		});
	}

	public async getBusinessProcessSelectList() {
		return this.clientService.post<BusinessProcessDictionaryDto[]>(`${this.prefix}/select-list`);
	}
}
